import { AccountType } from '@repo/types/enums/accountType';

export const getUserLvl = (lvl?: number, accountType?: AccountType) => {
  if (accountType === AccountType.Parent) {
    return 'Rodzic';
  }
  if (lvl === 0) {
    return 'Uczeń';
  }
  if (lvl === 1) {
    return 'Nauczyciel';
  }
  if (lvl === 2) {
    return 'Administrator';
  }
  return '';
};
